var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.596 14.6973L12.233 18.3893C11.693 18.7023 11 18.3233 11 17.6923V10.3083C11 9.67835 11.692 9.29835 12.233 9.61235L18.596 13.3043C18.7188 13.3745 18.8209 13.4758 18.892 13.5982C18.963 13.7205 19.0004 13.8594 19.0004 14.0008C19.0004 14.1423 18.963 14.2812 18.892 14.4035C18.8209 14.5259 18.7188 14.6272 18.596 14.6973Z",
    fill: "#FFCA3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayGroupIcon);
export default __webpack_public_path__ + "static/media/play-group-icon.f7d6245b587102e223a635cce0d88f30.svg";
export { ForwardRef as ReactComponent };